export default __webpack_public_path__ + "static/travel-case-2d670e9ed358942b894b87ebf73ab5ec.png";